module.exports = __webpack_public_path__ + "assets/img/0803.66d3dae5.svg";